import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BackdropLoader, Icon, InputWithIcon, SelectMenu } from '@livable/saas-react-components';
import { Checkbox, ListItemText, MenuItem, Paper, TextField } from '@mui/material';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';
import AllocationProgress from 'src/components/allocations/AllocationProgress';
import CurrentCycle from 'src/components/allocations/CurrentCycle';
import { SORT_VALUES } from 'src/constants/search';
import { USER_SETTINGS_KEYS } from 'src/constants/userSetting';
import { UTILITIES_STATUSES } from 'src/constants/utilities';
import { PROPERTY_STATUS_ENUM } from 'src/constants/property';
import { useStore } from 'src/stores';
import { completedSteps } from 'src/utils/allocations';
import { useDelay } from 'src/utils/hooks';
import useStyles from './styles';
export default function AllocationsTab(_ref) {
  var _store$allocations$cu2, _store$allocations$cu3, _store$allocations$cu4;
  let props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  const classes = useStyles(props);
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    filteredAddresses = _useState2[0],
    setFilteredAddress = _useState2[1];
  const _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    initialAddresses = _useState4[0],
    setInitialAddresses = _useState4[1];
  const _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    initialProperties = _useState6[0],
    setInitialProperties = _useState6[1];
  const _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    initialObj = _useState8[0],
    setInit = _useState8[1];
  const _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isLoading = _useState0[0],
    setIsLoading = _useState0[1];
  const _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isSearch = _useState10[0],
    setIsSearch = _useState10[1];
  const _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    properties = _useState12[0],
    setProperties = _useState12[1];
  const _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    searchValue = _useState14[0],
    setSearchValue = _useState14[1];
  const _useState15 = useState(SORT_VALUES.completed),
    _useState16 = _slicedToArray(_useState15, 2),
    sortBy = _useState16[0],
    setSortBy = _useState16[1];
  const completed = (a, b) => {
    if (a.completedSteps > b.completedSteps) {
      return -1;
    }
    if (a.completedSteps < b.completedSteps) {
      return 1;
    }
    return 0;
  };
  const asc = (a, b) => {
    if (a.propertyAddress < b.propertyAddress) {
      return -1;
    }
    if (a.propertyAddress > b.propertyAddress) {
      return 1;
    }
    return 0;
  };
  const updateProperties = (address, filtered) => {
    if (address && filtered.length !== initialAddresses.length) {
      setProperties(filtered);
    } else {
      setProperties([]);
    }
  };
  const search = query => {
    const filtered = initialAddresses.filter(address => {
      const status = initialObj[address].status;
      const values = [address, ...Object.keys(status)];
      const statusValues = Object.values(status);
      statusValues.forEach(val => values.push(...val));
      return values.some(val => val.toLowerCase().includes(query));
    });
    setFilteredAddress(filtered);
    updateProperties(query, filtered);
  };
  const handlePropertiesChange = (event, child) => {
    let filtered = [...filteredAddresses];
    const address = child.props.value;
    if (address) {
      const index = filtered.indexOf(address);
      if (index > -1) {
        filtered.splice(index, 1);
      } else {
        filtered = initialAddresses.filter(propertyAddress => filtered.includes(propertyAddress) || propertyAddress === address);
      }
    } else if (filtered.length === initialAddresses.length) {
      filtered = [];
    } else {
      filtered = [...initialAddresses];
    }
    setFilteredAddress(filtered);
    updateProperties(address, filtered);
    setIsSearch(false);
    setSearchValue('');
  };
  const handleSortByChange = event => {
    const sort = event.target.value;
    if (sort) {
      let initial = [...initialProperties];
      let filtered = [];
      filteredAddresses.forEach(address => filtered.push(initialObj[address]));
      setSortBy(sort);
      switch (sort) {
        case SORT_VALUES.uncompleted:
          initial = initial.sort(completed).reverse();
          filtered = filtered.sort(completed).reverse();
          break;
        case SORT_VALUES.asc:
          initial = initial.sort(asc);
          filtered = filtered.sort(asc);
          break;
        case SORT_VALUES.desc:
          initial = initial.sort(asc).reverse();
          filtered = filtered.sort(asc).reverse();
          break;
        case SORT_VALUES.completed:
          initial = initial.sort(completed);
          filtered = filtered.sort(completed);
        default:
          break;
      }
      filtered = filtered.map(f => f.propertyAddress);
      setInitialAddresses(initial.map(f => f.propertyAddress));
      setInitialProperties(initial);
      setFilteredAddress(filtered);
      updateProperties(searchValue, filtered);
    }
  };
  const mergeData = () => {
    const compProperties = [...store.company.propertiesList];
    const inObj = {};
    compProperties.forEach(property => {
      const status = {};
      Object.keys(UTILITIES_STATUSES).forEach(key => status[key] = []);
      const types = new Map();
      property.utilities.forEach(u => types.set(u.utilityId, u.utilityType));
      if (store.allocations.billAllocationsList.get(property.propertyId)) {
        let propertyUtilities = [...property.utilities];
        property.utilities = [];
        const pushUtility = utility => property.utilities.push({
          allocation: _objectSpread({}, utility),
          utilityId: utility.utilityId,
          utilityType: types.get(utility.utilityId)
        });
        store.allocations.billAllocationsList.get(property.propertyId).forEach(allocation => {
          pushUtility(allocation);
          const billStatus = allocation.billStatus;
          status[billStatus].push(types.get(allocation.utilityId));
        });
        const remainderIds = property.utilities.map(u => u.utilityId);
        propertyUtilities.filter(u => !remainderIds.includes(u.utilityId)).forEach(u => {
          pushUtility(u);
          status.PendingCompletion.push(types.get(u.utilityId));
        });
      } else {
        property.utilities.forEach(u => status.PendingCompletion.push(u.utilityType));
      }
      property.completedSteps = completedSteps(status);
      property.status = _objectSpread({}, status);
      inObj[property.propertyAddress] = property;
    });
    setInit(inObj);
    return compProperties;
  };
  useDelay(() => isSearch && search(searchValue === null || searchValue === void 0 ? void 0 : searchValue.toLowerCase()), [searchValue], 1000);
  const getBillsAllocations = async data => {
    const resp = await store.allocations.getBillsAsync.run(data);
    return resp;
  };
  const getCompanyProperties = async () => {
    const resp = await store.company.getCompanyPropertiesAsync.run();
    return resp;
  };
  const getCurrentCycle = async data => {
    const resp = await store.allocations.getCurrentCycleAsync.run(data);
    return resp;
  };
  useEffect(() => {
    setIsLoading(true);
    const companyId = localStorage.getItem(USER_SETTINGS_KEYS.company);
    if (companyId) Promise.all([getCompanyProperties(), getCurrentCycle({
      companyId
    })]).then(async () => {
      var _store$allocations$cu;
      getBillsAllocations({
        allocationCycleId: (_store$allocations$cu = store.allocations.currentCycle) === null || _store$allocations$cu === void 0 ? void 0 : _store$allocations$cu.id,
        propertyIds: store.company.propertyIds
      }).then(async () => {
        const mergedData = mergeData().filter(p => p.propertyStatus !== PROPERTY_STATUS_ENUM.Inactive).sort(completed);
        setInitialProperties(mergedData);
        const addresses = [...mergedData.map(property => property.propertyAddress)];
        setFilteredAddress(addresses);
        setInitialAddresses(addresses);
        setIsLoading(false);
      });
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }), /*#__PURE__*/React.createElement(CurrentCycle, {
    daysTillStatementDate: (_store$allocations$cu2 = store.allocations.currentCycle) === null || _store$allocations$cu2 === void 0 ? void 0 : _store$allocations$cu2.daysTillStatementDate,
    name: (_store$allocations$cu3 = store.allocations.currentCycle) === null || _store$allocations$cu3 === void 0 ? void 0 : _store$allocations$cu3.name,
    statementDate: moment((_store$allocations$cu4 = store.allocations.currentCycle) === null || _store$allocations$cu4 === void 0 ? void 0 : _store$allocations$cu4.statementDate).format('L')
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.searchBar
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.searchField
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "charges-search",
    label: t('allocations.search_in_list'),
    onChange: e => {
      setIsSearch(true);
      setSearchValue(e.target.value);
    },
    variant: "outlined",
    value: searchValue
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.filterSelector, " ").concat(classes.filterSelectorMd)
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "sort-properties",
    label: t('allocations.properties'),
    labelId: "sort-properties-label",
    multiple: true,
    onChange: handlePropertiesChange,
    renderValue: selected => selected.join(', '),
    value: properties
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: "",
    variant: "multiple"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: filteredAddresses.length === initialAddresses.length
  }), /*#__PURE__*/React.createElement(ListItemText, null, t('allocations.select_all_properties'))), initialAddresses.map(address => /*#__PURE__*/React.createElement(MenuItem, {
    key: uuid(),
    value: address,
    variant: "multiple"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: filteredAddresses.includes(address)
  }), /*#__PURE__*/React.createElement(ListItemText, {
    primary: address
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.filterSelector, " ").concat(classes.filterSelectorSm)
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "sort-by-selector",
    label: t('allocations.sort_by'),
    labelId: "sort-by-selector-label",
    onChange: handleSortByChange,
    value: sortBy
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: SORT_VALUES.completed
  }, t('allocations.completed_first')), /*#__PURE__*/React.createElement(MenuItem, {
    value: SORT_VALUES.uncompleted
  }, t('allocations.uncompleted_first')), /*#__PURE__*/React.createElement(MenuItem, {
    value: SORT_VALUES.asc
  }, t('allocations.name_ascending')), /*#__PURE__*/React.createElement(MenuItem, {
    value: SORT_VALUES.desc
  }, t('allocations.name_descending')))))), filteredAddresses.map(address => {
    var _store$allocations$cu5, _store$allocations$cu6;
    return /*#__PURE__*/React.createElement(AllocationProgress, {
      allocation: initialObj[address],
      allocationCycleId: (_store$allocations$cu5 = store.allocations.currentCycle) === null || _store$allocations$cu5 === void 0 ? void 0 : _store$allocations$cu5.id,
      key: uuid(),
      statementDate: moment((_store$allocations$cu6 = store.allocations.currentCycle) === null || _store$allocations$cu6 === void 0 ? void 0 : _store$allocations$cu6.statementDate).format('L')
    });
  }));
}